import { render, staticRenderFns } from "./Learn-detailcopy.vue?vue&type=template&id=55fafe8f&scoped=true&"
import script from "./Learn-detailcopy.vue?vue&type=script&lang=js&"
export * from "./Learn-detailcopy.vue?vue&type=script&lang=js&"
import style0 from "./Learn-detailcopy.vue?vue&type=style&index=0&id=55fafe8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fafe8f",
  null
  
)

export default component.exports